import SmartBanner, { BANNER_HEIGHT, SMART_BANNER_CLOSE_EVENT, loadSmartBannerIsCloseFromCookie } from './SmartBanner';

export { BANNER_HEIGHT, SMART_BANNER_CLOSE_EVENT, loadSmartBannerIsCloseFromCookie };
export default SmartBanner;
